import React from 'react';

function PFTForm() {
  return (
    <div>
      <h2>PFTForm</h2>
    </div>
  );
}

export default PFTForm;
